import { motion } from "framer-motion";
import React from "react";

const EASE = [0.22, 1, 0.36, 1];

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line text reveal (on load or in view)
export const MaskLines = ({ lines, className = "", delay = 0, once = true }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={once ? undefined : {}}
          whileInView={once ? undefined : {}}
          {...(once
            ? { animate: { y: 0 } }
            : { whileInView: { y: 0 }, viewport: { once: true } })}
          transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.11 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: EASE },
};

export { EASE };
